export default {
  partners: [],
  taxes: [],
  groupPayments: [],
  regionMunicipalities:[],
  detailsPayments:[],
  terminalPayments:[],
  invoice:null

}
